import { InjectionToken } from "@angular/core";
import { SafeResourceUrl } from "@angular/platform-browser";
import { Observable } from "rxjs";

export const URL_PROVIDER_SERVICE = new InjectionToken<IUrlProvider>('URL_PROVIDER_SERVICE');

export interface IUrlProvider {
    url$: Observable<string>;
    safeUrl$: Observable<SafeResourceUrl>;
}